<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="position: absolute;z-index: 999;margin-top: 10px;margin-left: 10px;width: 200px;height: 50px">
      <el-select v-fixZoom v-model="dId" filterable placeholder="请选择" style="width:100%;" @change="personChange">
        <el-option v-for="item in personArr" :key="item.index" :label="item.person_name" :value="item.did">
          <span>{{ getSelectElderlyShow(item) }}</span>
        </el-option>
      </el-select>
    </div>
    <div style="height: 100%">
      <iframe id="mainIframe"
              ref="mainIframe"
              name="mainIframe"
              :style="{width: '100%', height: '100%', margin: 'auto', zoom: 1 / this.golobleObject.zoom}"
              src="../../../static/showMonitorLocation.html"
              frameborder="0"
              scrolling="no">
      </iframe>
    </div>
  </div>
</template>

<script>
import {querypersonlocation} from '../../api/yanglaoyuan/dataScreen'
import {sendcommand} from '../../api/device'

export default {
  name: 'siteMonitor',
  data () {
    return {
      entityId: 0,
      isQuery: false,
      isMap: false,

      dId: '',
      personArr: [],
      selectPerson: '',
      timeNum: 0, // 刷新次数
      timerShow: null // 5秒定时器刷新数据
    }
  },
  created () {
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.golobleObject.childMapSend = this.getStartMarker // 地图加载完
    this.golobleObject.getSiteLocation = this.getSendSite
    this.getPersonLocation()
  },
  destroyed () {
    this.timeNum = 0
    clearInterval(this.timerShow)
    this.timerShow = null
  },
  methods: {
    // 获取位置 按钮
    getSendSite (did) {
      let person = this.personArr.find(r => r.did === did)
      // console.log('发送指令', person.ptime)
      this.selectPerson = person
      if (person) {
        // 定位模式 按次定位 发送指令
        let data = {
          imei: person.device_id,
          did: person.did,
          method: 'requirelocation',
          command1: '1',
          command2: '2',
          command3: '1',
          command4: '2',
          command5: '',
          reserved1: '',
          reserved2: ''
        }
        sendcommand(data).then(res => {
          this.$notify({
            title: '成功',
            message: '成功发送',
            type: 'success'
          })
          let vm = this
          this.timerShow = setInterval(() => {
            vm.timeNum = vm.timeNum + 5
            if (vm.timeNum < 61) {
              vm.getPersonLocation()
            } else {
              vm.timeNum = 0
              clearInterval(vm.timerShow)
              vm.timerShow = null
            }
          }, 5000)
          this.getPersonLocation()
        }).catch(() => {
          this.$notify.error({
            title: '失败',
            message: '发送失败'
          })
        })
      }
    },
    getStartMarker () {
      this.isMap = true
      if (this.isQuery && this.isMap) {
        window.frames['mainIframe'].window.getParentAdd(this.personArr)
      }
    },
    getPersonLocation () {
      let data = {
        eid: this.entityId
      }
      querypersonlocation(data).then(res => {
        if (this.timerShow) {
          // console.log('定时器', this.timeNum)
          let arr = res.data.location
          // 定时器刷新数据 有位置变化就更新
          let vm = this
          let ischange = arr.find(val => val.did === vm.selectPerson.did && val.ptime !== vm.selectPerson.ptime)
          if (ischange) {
            // console.log('定时器1', ischange.lat, ischange.lng)
            vm.personArr = res.data.location
            window.frames['mainIframe'].window.changeDidLocation(ischange)
            vm.timeNum = 0
            clearInterval(vm.timerShow)
            vm.timerShow = null
          } else {
            if (vm.timeNum === 60) {
              this.$message({
                message: '暂无位置上报。',
                type: 'warning'
              })
            }
          }
        } else {
          // 首次获取数据
          this.personArr = res.data.location
          this.isQuery = true
          if (this.isQuery && this.isMap) {
            window.frames['mainIframe'].window.getParentAdd(this.personArr)
          }
        }
      })
    },

    getSelectElderlyShow (item) {
      let dType = ''
      if (item.devicetype === 700) {
        dType = '【智能网关】'
      } else {
        dType = '【' + this.commonType.getDeviceType(item.devicetype) + '】'
      }
      let elderlyName = item.person_name && item.person_name !== '' ? item.person_name : '--'
      let buildName = item.build_name && item.build_name !== '' ? item.build_name : '--'
      let floorName = item.floor_name && item.floor_name !== '' ? item.floor_name : '--'
      let roomName = item.home_name && item.home_name !== '' ? item.home_name : '--'
      let bedName = item.bed_name && item.bed_name !== '' ? item.bed_name : '--'
      return dType + elderlyName + ' / ' + buildName + '--' + floorName + '--' + roomName + '--' + bedName
    },
    personChange () {
      let person = this.personArr.find(r => r.did === this.dId)
      if (person) {
        window.frames['mainIframe'].window.showOnePerson(person)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/siteMonitor.vue